export default __webpack_public_path__ + "static/media/streamer_avatar7.2ca00433.png";